import graphql from "babel-plugin-relay/macro";

const AllPollsQuery = graphql`
query AllPollsQuery{
  allPolls {
    edges {
      node {
        id
        pollName
        question
        isCompleted
        pollChoices {
          edges {
            node {
              choice
              choicePercentage
              id
            }
          }
        }
        reward
        
      }
    }
  }
}
`

export default AllPollsQuery
// old polls query
// pollParticipation {
//           edges {
//             node {
//               poll {
//                 pollName
//                 pollChoices {
//                   edges {
//                     node {
//                       id
//                       choice
//                       choicePercentage
//                     }
//                   }
//                 }
//               }
//               answer {
//                 id
//                 choice
//               }
//             }
//           }
//         }